import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DsButtonModule } from '@bmw-ds/components';

import { DealerProvider } from '../../../../auth/dealer/dealer.provider';
import { CustomerVehicle, CustomerVehicleRelationType } from '../../../customer/model/customer-vehicle.model';
import { useI18n } from '../../../i18n/services/i18n.service';
import { VerifyChoiceModalWrapper } from '../../../modal/verify-choice-modal/verify-choice-modal.wrapper';
import { VehicleInfoComponent } from '../vehicle-info/vehicle-info.component';

@Component({
  selector: 'cdf-remove-relation-modal',
  imports: [DsButtonModule, VehicleInfoComponent, VerifyChoiceModalWrapper],
  template: `
    <cdf-verify-choice-modal-wrapper
      isDestructiveAction
      class="remove-relation-modal"
      [open]="true"
      size="lg"
      [headingText]="i18n('vehicles.removeRelationVerifyModal.heading')"
      [bodyText]="verifyRemoveRelationModalBody"
      [verifyButtonText]="i18n('vehicles.removeRelationVerifyModal.removeButton')"
      [buttonLoading]="loading()"
      (verify)="confirmRemove.emit()"
      (closeEvent)="hideModal.emit()"
    />
    <ng-template #verifyRemoveRelationModalBody>
      <p class="text-regular mb-3x">{{ i18n('vehicles.removeRelationVerifyModal.relationWillBeRemoved') }}</p>

      <cdf-vehicle-info
        [vehicle]="vehicle()"
        [activeCountry]="dealerProvider.activeCountry()"
        [markRelationDestructive]="relationToRemove()"
      />

      <p class="text-regular mt-3x">{{ i18n('vehicles.removeRelationVerifyModal.mainMessage') }}</p>

      <p class="text-regular mt-2x">
        {{ i18n('vehicles.removeRelationVerifyModal.messageRemoveVehicle') }}
        <button
          ds-button
          (click)="switchToRemoveVehicleModal.emit()"
          variant="ghost-destructive"
          size="sm"
          [disabled]="loading()"
        >
          {{ i18n('vehicles.removeVehicleVerifyModal.removeButton') }}
        </button>
      </p>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveRelationModalWrapper {
  protected readonly i18n = useI18n();
  protected readonly dealerProvider = inject(DealerProvider);

  readonly vehicle = input.required<CustomerVehicle>();
  readonly relationToRemove = input.required<CustomerVehicleRelationType>();

  readonly loading = input(false);

  readonly confirmRemove = output();
  readonly hideModal = output();
  readonly switchToRemoveVehicleModal = output();
}
